import { useState } from "react";

const HeadingInput = ({ value, onChange, readOnly, onFocus, color }) => {
  const [focused, setFocused] = useState(false);

  return (
    <input
      placeholder="یک عنوان وارد کنید"
      style={{
        border: "none",
        outline: "none",
        width: "100%",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: 1.45,
        color,
        marginBottom:'16px'
      }}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={() => setFocused(false)}
      data-focused={focused}
    />
  );
};

export default HeadingInput;
